/* global axios */
import ApiClient from './ApiClient';

class AppointmentReminderTemplatesAPI extends ApiClient {
  constructor() {
    super('appointment_reminder_templates', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  getActive() {
    return axios.get(this.url, { params: { active_only: 'true' } });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data) {
    return axios.post(this.url, data);
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new AppointmentReminderTemplatesAPI();
